let currentVehicles = [];

function add(data) {
    currentVehicles.push(data);
}

function commit() {
    window.dataLayer = window.dataLayer || [];
    setTimeout(() => {
        window.dataLayer.push({
            list_productidsall: currentVehicles,
        });

        currentVehicles = [];
    }, 0);
}

module.exports = {
    add: add,
    commit: commit,
};



// WEBPACK FOOTER //
// ./src/dealer-gtm.js